module.exports = __webpack_public_path__ + "static/media/startCommunity.dc208845.png";


//////////////////
// WEBPACK FOOTER
// ./src/startCommunity.png
// module id = 542
// module chunks = 0